import { useEffect, useState } from 'react';

/** How long the confirm step stays open without an answer. */
const CONFIRM_MS = 6000;

/**
 * The match host's End match button, at the foot of the player list. Ending
 * is irreversible, so it asks first: the button turns into a short confirm
 * row (Cancel / End for everyone) that closes itself after a few seconds.
 * The match then ends scored as at the time limit (systems/victory.ts).
 */
export function EndMatchControl({ onEnd }: { onEnd: () => void }) {
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    if (!confirming) return;
    const timer = setTimeout(() => setConfirming(false), CONFIRM_MS);
    return () => clearTimeout(timer);
  }, [confirming]);

  if (!confirming) {
    return (
      <div className="mt-1.5 border-t border-line pt-1.5">
        <button
          type="button"
          onClick={() => setConfirming(true)}
          title="End the match now for everyone; the highest score wins"
          className="btn btn-ghost h-6 w-full px-2 text-xs text-fg-muted"
        >
          End match
        </button>
      </div>
    );
  }
  return (
    <div className="mt-1.5 border-t border-line pt-1.5" role="alertdialog" aria-label="End match">
      <p className="text-fg-muted">End the match for everyone? The highest score wins.</p>
      <div className="mt-1.5 flex gap-1.5">
        <button
          type="button"
          onClick={() => setConfirming(false)}
          className="btn btn-secondary h-6 flex-1 px-2 text-xs"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={() => {
            setConfirming(false);
            onEnd();
          }}
          className="btn h-6 flex-1 bg-danger-surface px-2 text-xs text-danger hover:bg-danger/30"
        >
          End match
        </button>
      </div>
    </div>
  );
}
